@if (iShowPayments) {
  <div>
    @if (iTotalPaymentDetails?.length) {
      <div class="payment-list-toolbar">
        @if (iTotalPaymentDetails?.length) {
          <div class="payment-list-summary">
            @for (details of iTotalPaymentDetails; track details) {
              <span class="payment-summary-chip">
                {{ formatPaymentMethod(details.paymentMethod) }} : {{ details.total }} €
              </span>
            }
          </div>
        }
      </div>
    }
    <table class="table payment-table">
      <thead>
        <tr>
          @if (iShowInvoiceNumber) {
            <th scope="col" class="col-invoice">N°</th>
          }
          <th scope="col" class="col-date">DATE</th>
          <th scope="col" class="col-montant">MONTANT</th>
          @if (!iNavMobile) {
            <th scope="col" class="col-mode">MODE</th>
          }
          @if (iShowStudent) {
            <th scope="col" class="col-eleve">ELEVE</th>
          }
          @if (!isDisabled && !iNavMobile && !iIsStudent) {
            <th scope="col" class="col-description">DESCRIPTION</th>
          }
          <th scope="col" class="col-documents">DOCUMENTS</th>
        </tr>
      </thead>
      <tbody>
        @for (p of iPayments; track p) {
          <tr [class.refund-row]="p.paymentType === 'REFUND'">
            @if (iShowInvoiceNumber) {
              <td class="col-invoice">{{formatInvoiceNumber(p.invoiceNumber)}}</td>
            }
            <td class="col-date">{{p.date | date:'dd/MM/yyyy'}}</td>
            <td class="col-montant">{{p.amount}} €</td>
            @if (!iNavMobile) {
              <td class="col-mode">
                <div class="payment-mode-stack">
                  <span class="payment-method-badge" [ngClass]="'payment-method-badge--' + getPaymentMethodVariant(p.paymentMethod)">
                    {{ formatPaymentMethod(p.paymentMethod) }}
                  </span>
                  @if (p.paymentType === 'REFUND') {
                    <span class="payment-refund-badge">Remboursement</span>
                  }
                </div>
              </td>
            }
            @if (iShowStudent) {
              <td class="col-eleve">{{p.studentName}}</td>
            }
            @if (!isDisabled && !iNavMobile && !iIsStudent) {
              <td class="col-description">{{p.description}}</td>
            }
            <td class="col-documents">
              <div class="payment-documents-actions">
                @if (canDownloadInvoice(p)) {
                  <button type="button"
                    class="btn btn-sm btn-outline-primary payment-document-btn"
                    (click)="uploadInvoice(p.paymentId)"
                    title="Télécharger la facture"
                    aria-label="Télécharger la facture">
                    <i class="fa fa-file-pdf-o"></i>
                    @if (!iNavMobile) {
                      <span>Facture</span>
                    }
                  </button>
                }
                @if (canDownloadReceipt(p)) {
                  <button type="button"
                    class="btn btn-sm btn-outline-secondary payment-document-btn"
                    (click)="uploadReceipt(p.paymentId)"
                    title="Télécharger le justificatif de paiement"
                    aria-label="Télécharger le justificatif de paiement">
                    <i class="fa fa-download"></i>
                    @if (!iNavMobile) {
                      <span>Justificatif</span>
                    }
                  </button>
                }
                @if (!canDownloadInvoice(p) && !canDownloadReceipt(p)) {
                  <span class="payment-documents-empty">-</span>
                }
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
    @if (iPagePayment) {
      <app-pagination [iEmpty]="iPagePayment.empty" [iFirst]="iPagePayment.first"
        [iLast]="iPagePayment.last" [iNumber]="iPagePayment.number" [iTotalPages]="iPagePayment.totalPages"
        [iPageSize]="iPagePayment.size"
        (currentPageChanged)="onChangePaymentPage($event)">
      </app-pagination>
    }
  </div>
}
